<template>
    <div>
        <widget
            :id="'connection-type-detail'"
            :title="$tc('phrases.connectionTypeDetails')"
            :subscriber="subscriber.detail"
        >
            <md-card>
                <md-card-content>
                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-size-50 md-small-size-100">
                            <div class="md-layout">
                                <div class="md-layout-item md-subheader">{{ $tc('words.name') }}</div>
                                <div v-if="isViewMode" class="md-layout-item md-subheader n-font">
                                    {{ connectionType.name }}
                                    <md-button class="md-icon-button" @click="toggleEditConnectionType">
                                        <md-icon>edit</md-icon>
                                    </md-button>

                                </div>
                                <div v-else class="md-layout-item md-subheader n-font">
                                    <md-field :class="{'md-invalid': errors.has($tc('phrases.connectionType'))}">
                                        <label for="connectionTypeName">{{ $tc('phrases.editConnectionType') }}</label>
                                        <md-input
                                            id="connectionTypeName"
                                            :name="$tc('phrases.connectionType')"
                                            v-model="connectionType.name"
                                            v-validate="'required|min:3'"
                                        />
                                        <span class="md-error">{{ errors.first($tc('phrases.connectionType')) }}</span>
                                        <md-button class="md-icon-button" @click="editConnectionTypeName">
                                            <md-icon>save</md-icon>
                                        </md-button>
                                        <md-button class="md-icon-button" @click="toggleEditConnectionType">
                                            <md-icon>close</md-icon>
                                        </md-button>
                                    </md-field>

                                </div>
                            </div>
                            <hr class="hr-d">
                            <div class="md-layout">
                                <div class="md-layout-item md-subheader">{{ $tc('phrases.createdAt') }}</div>
                                <div class="md-layout-item md-subheader n-font">
                                    {{ timeForTimeZone(connectionType.created_at) }}
                                </div>
                            </div>
                        </div>
                        <div class="md-layout-item md-size-50 md-small-size-100">
                            <div class="md-layout">
                                <div class="md-layout-item md-subheader">{{ $tc('words.meter', 2) }}</div>
                                <div class="md-layout-item md-subheader n-font">
                                    {{ connectionType.meters_count || 0 }}
                                </div>
                            </div>
                            <hr class="hr-d">
                            <div class="md-layout">
                                <div class="md-layout-item md-subheader">{{ $tc('phrases.subTypes') }}</div>
                                <div class="md-layout-item md-subheader n-font">
                                    {{ subConnectionTypes.length }}
                                </div>
                            </div>

                        </div>
                    </div>
                </md-card-content>
            </md-card>
        </widget>
        <widget
            :title="$tc('phrases.newSubConnectionType') "
            :id="'add-sub-connection-type'"
            color="red"
            v-if="showNewSubType"
        >
            <md-card>

                <md-card-content>
                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-size-100">
                            <md-field :class="{'md-invalid': errors.has($tc('words.name'))}">
                                <label for="name">{{ $tc('words.name') }}</label>
                                <md-input
                                    id="name"
                                    :name="$tc('words.name')"
                                    v-model="newSubConnectionType.name"
                                    v-validate="'required|min:3'"
                                />
                                <span class="md-error">{{ errors.first($tc('words.name')) }}</span>
                            </md-field>

                        </div>
                    </div>
                </md-card-content>

                <md-card-actions>
                    <md-button role="button" class="md-raised md-primary" @click="saveSubType">
                        {{ $tc('words.save') }}
                    </md-button>
                    <md-button role="button" class="md-raised" @click="addSubType">{{ $tc('words.close') }}</md-button>
                </md-card-actions>
            </md-card>

        </widget>
        <widget
            :title="$tc('phrases.subConnectionTypes')"
            :id="'sub-connection-types'"
            :button="true"
            :button-text="$tc('phrases.newSubConnectionType')"
            @widgetAction="addSubType"
            :color="'green'"
            :subscriber="subscriber.subTypes">
            <md-card>
                <md-card-content>
                        <md-table>
                            <md-table-row>
                                <md-table-head>{{$tc('words.name')}}</md-table-head>
                                <md-table-head>{{$tc('words.createdAt')}}</md-table-head>
                                <md-table-head></md-table-head>

                            </md-table-row>
                            <md-table-row v-for="subType in subConnectionTypes" :key="subType.id">
                                <md-table-cell>
                                    <div v-if="editSubConnectionType === subType.id">
                                        <md-field :class="{'md-invalid': errors.has($tc('words.name'))}">
                                            <label :for="`subConnectionTypeName-${subType.id}`">{{ $tc('phrases.editSubConnectionType') }}</label>
                                            <md-input
                                                :id="`subConnectionTypeName-${subType.id}`"
                                                :name="$tc('words.name')"
                                                v-model="subType.name"
                                                v-validate="'required|min:3'"
                                            />
                                            <span class="md-error">{{ errors.first($tc('words.name')) }}</span>

                                        </md-field>
                                    </div>
                                    <div v-else>
                                        {{subType.name}}
                                    </div>
                                </md-table-cell>
                                <md-table-cell>{{ timeForTimeZone(subType.created_at) }}</md-table-cell>
                                <md-table-cell>
                                    <div v-if="editSubConnectionType === subType.id">
                                        <md-button class="md-icon-button" @click="updateSubConnectionType(subType)">
                                            <md-icon>save</md-icon>
                                        </md-button>
                                        <md-button class="md-icon-button" @click="cancelSubConnectionTypeEdit">
                                            <md-icon>close</md-icon>
                                        </md-button>
                                    </div>
                                    <div v-else>
                                        <md-button class="md-icon-button" @click="startSubConnectionTypeEdit(subType)">
                                            <md-icon>edit</md-icon>
                                        </md-button>
                                    </div>
                                </md-table-cell>
                            </md-table-row>
                        </md-table>
                </md-card-content>
            </md-card>
        </widget>

    </div>
</template>

<script>
import Widget from '../../shared/widget'
import { SubConnectionTypeService } from '@/services/SubConnectionTypeService'
import { ConnectionTypeService } from '@/services/ConnectionTypeService'
import { EventBus } from '@/shared/eventbus'
import { timing } from '@/mixins/timing'

export default {
    name: 'ConnectionTypeDetail',
    mixins: [timing],
    components: { Widget },
    data () {
        return {
            subscriber: {
                detail: 'connection-type-detail',
                subTypes: 'sub-connection-types'
            },
            connectionTypeService: new ConnectionTypeService(),
            subConnectionTypeService: new SubConnectionTypeService(),
            showNewSubType: false,
            isViewMode: true,
            editSubConnectionType: null,
            editingSubConnectionTypeSnapshot: null,
            newSubConnectionType: {
                name: null,
                connection_type_id: null,
            },
            connectionTypeId: null,
            connectionType: {},
            subConnectionTypes: [],
        }
    },
    created () {
        this.connectionTypeId = this.$route.params.id
        this.newSubConnectionType.connection_type_id = this.connectionTypeId
        this.loadPageData()
    },
    methods: {
        async loadPageData () {
            await Promise.all([
                this.getConnectionTypeDetail(this.connectionTypeId),
                this.getSubConnectionTypes(this.connectionTypeId),
            ])
        },
        checkConfirm (result) {
            return 'value' in result
        },
        startSubConnectionTypeEdit (subType) {
            this.editingSubConnectionTypeSnapshot = {
                id: subType.id,
                name: subType.name,
            }
            this.editSubConnectionType = subType.id
        },
        cancelSubConnectionTypeEdit () {
            if (this.editingSubConnectionTypeSnapshot) {
                const subType = this.subConnectionTypes.find(
                    item => item.id === this.editingSubConnectionTypeSnapshot.id
                )
                if (subType) {
                    subType.name = this.editingSubConnectionTypeSnapshot.name
                }
            }
            this.editSubConnectionType = null
            this.editingSubConnectionTypeSnapshot = null
        },
        async updateSubConnectionType (subType) {
            let validator = await this.$validator.validateAll()
            if (!validator) {
                return
            }
            this.$swal({
                type: 'question',
                title: this.$tc('phrases.editSubConnectionType'),
                text: this.$tc('phrases.editSubConnectionTypeNotify', 1),
                showCancelButton: true,
                cancelButtonText: this.$tc('words.no'),
                confirmButtonText: this.$tc('words.yes')
            }).then(async response => {
                if (this.checkConfirm(response)) {
                    try {
                        await this.subConnectionTypeService.updateSubConnectionType(subType)
                        await this.getSubConnectionTypes(this.connectionTypeId)
                        this.editSubConnectionType = null
                        this.editingSubConnectionTypeSnapshot = null
                        this.alertNotify('success', this.$tc('phrases.editSubConnectionTypeNotify', 2))
                    } catch (e) {
                        this.alertNotify('error', e.message)
                    }
                }
            })
        },
        async editConnectionTypeName () {
            let validator = await this.$validator.validateAll()
            if (!validator) {
                return
            }
            this.$swal({
                type: 'question',
                title: this.$tc('phrases.editConnectionType'),
                text: this.$tc('phrases.editConnectionTypeNotify', 2, { name: this.connectionType.name }),
                showCancelButton: true,
                cancelButtonText: this.$tc('words.no'),
                confirmButtonText: this.$tc('words.yes')
            }).then(async response => {
                if (this.checkConfirm(response)) {
                    try {
                        await this.connectionTypeService.updateConnectionType(this.connectionType)
                        this.toggleEditConnectionType()
                        this.alertNotify('success', this.$tc('phrases.editConnectionTypeNotify', 1))
                    } catch (e) {
                        this.alertNotify('error', e.message)
                    }
                }
            })

        },
        toggleEditConnectionType () {
            this.isViewMode = !this.isViewMode
        },
        addSubType () {
            this.showNewSubType = !this.showNewSubType
        },
        clearForm () {
            this.newSubConnectionType.name = null
        },
        async saveSubType () {
            let validator = await this.$validator.validateAll()
            if (!validator) {
                return
            }
            try {
                await this.subConnectionTypeService.createSubConnectionType(this.newSubConnectionType)
                await this.getSubConnectionTypes(this.connectionTypeId)
                this.alertNotify('success', this.$tc('phrases.newSubConnectionType', 2))
                this.addSubType()
                this.clearForm()
            } catch (e) {
                this.alertNotify('error', e.message)
            }

        },
        async getConnectionTypeDetail (connectionTypeId) {
            try {
                this.connectionType = await this.connectionTypeService.getConnectionTypeDetail(connectionTypeId)
                EventBus.$emit('widgetContentLoaded', this.subscriber.detail, this.connectionType)
            } catch (e) {
                this.alertNotify('error', e.message)
            }
        },
        async getSubConnectionTypes (connectionTypeId) {
            try {
                await this.subConnectionTypeService.getSubConnectionTypes(connectionTypeId)
                this.subConnectionTypes = [...this.subConnectionTypeService.subConnectionTypes]
                EventBus.$emit('widgetContentLoaded', this.subscriber.subTypes, this.subConnectionTypes.length)
            } catch (e) {
                this.alertNotify('error', e.message)
            }

        },
        alertNotify (type, message) {
            this.$notify({
                group: 'notify',
                type: type,
                title: type + ' !',
                text: message
            })
        },
    }
}
</script>

<style scoped>
.n-font {
    font-weight: 100 !important;
}

.hr-d {
    height: 1pt;
    margin: auto;
    padding: 0;
    display: block;
    border: 0;
    background-color: rgba(0, 0, 0, 0.12);
}
</style>
